import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e724db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "header",
  id: "header"
}
const _hoisted_2 = { class: "principally content" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "menu" }
const _hoisted_6 = { class: "item_w" }
const _hoisted_7 = { style: {"display":"flex"} }
const _hoisted_8 = { class: "item_w" }
const _hoisted_9 = { class: "item_w" }
const _hoisted_10 = { style: {"display":"flex"} }
const _hoisted_11 = { class: "item_w" }
const _hoisted_12 = { class: "item_w" }
const _hoisted_13 = { class: "item_w" }

import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import logo from "@/static/logo.png";

import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'eHeader',
  setup(__props) {

const handleSelect = (key: string, keyPath: string[]) => {
  console.log(key, keyPath);
};

onMounted(() => {
  handleScroll();
});
onBeforeUnmount(() => {
  window.removeEventListener("scroll", () => {
    handleScroll();
  }); // 离开当前组件别忘记移除事件监听
});

// 滚动事件 控制menu的显示状态
let oldScrollTop = 0; // 记录上一次滚动结束后的滚动距离
const scrollTop = ref<number>(0); // 记录当前的滚动距离
const scrollFixedStatus = ref<boolean>(true);
const handleScroll = () => {
  window.addEventListener("scroll", () => {
    scrollTop.value = window.scrollY;

    if (scrollTop.value >= 50) {
      document
        .getElementById("header")
        ?.setAttribute(
          "style",
          "background-color: #3D4148;transition: all 0.6s linear;"
        );
    } else {
      document
        .getElementById("header")
        ?.setAttribute(
          "style",
          "background-color: rgba(0, 0, 0, 0);transition: all 0.6s linear;"
        );
    }
  });
};

const openMenu = () => {
  document
    .getElementById("header")
    ?.setAttribute(
      "style",
      "background-color: #3D4148;transition: all 0.6s linear;"
    );
};

const closeMenu = () => {
  if (scrollTop.value <= 0) {
    document
      .getElementById("header")
      ?.setAttribute(
        "style",
        "background-color: rgba(0, 0, 0, 0);transition: all 0.6s linear;"
      );
  }
};

watch(
  () => scrollTop.value,
  (newValue: number, oldValue: number) => {
    setTimeout(() => {
      if (newValue === window.scrollY) {
        // 延时执行后当newValue等于window.scrollY，代表滚动结束
        oldScrollTop = newValue; // 每次滚动结束后都要给oldScrollTop赋值
        // scrollFixedStatus.value = true;
      }
    }, 20); // 必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
    if (oldScrollTop === oldValue) {
      scrollFixedStatus.value = false;
      // 每次滚动开始时oldScrollTop与oldValue相等
    }
  }
);
const activeIndex2 = ref("/");
const activeIndex = ref("");

const userRouter = useRouter();
watch(
  () => userRouter.currentRoute.value.fullPath,
  (val: string) => {
    if (val.split("/")[0] === "" && val.split("/")[1] === "") {
      activeIndex.value = activeIndex2.value = "/";
    } else {
      activeIndex2.value = val.split("/")[2];
      activeIndex.value = val.split("/")[1];
    }
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(logo),
              alt: ""
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_menu, {
          "default-active": activeIndex2.value,
          class: "el-menu-demo",
          mode: "horizontal",
          "background-color": "transparent",
          "text-color": "#fff",
          "active-text-color": "#ffd04b",
          onSelect: handleSelect,
          onOpen: openMenu,
          onClose: closeMenu
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "1" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["menu_name", activeIndex2.value === '/' ? 'menuActive' : 'menuActive2'])
                    }, " 首页 ", 2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "2" }, {
              title: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(
                  activeIndex.value === 'coreTechnology' ? 'menuActive' : 'menu_name'
                )
                }, " 核心技术 ", 2)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_menu_item, { index: "weatherAI" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/coreTechnology/weatherAI" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(
                      activeIndex2.value == 'weatherAI' ? 'menuActive' : 'menu_name'
                    )
                          }, " 气象AI数据服务平台 ", 2)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "3" }, {
              title: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(
                  activeIndex.value === 'productService' ? 'menuActive' : 'menu_name'
                )
                }, " 产品服务 ", 2)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_menu_item, { index: "integrationPlatform" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/productService/integrationPlatform" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'integrationPlatform'
                          ? 'menuActive'
                          : 'menu_name'
                      )
                            }, " 气象预报预警平台 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "dataProduct" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/dataProduct/0/00" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'dataProduct'
                          ? 'menuActive'
                          : 'menu_name'
                      )
                            }, " 气象数据产品 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "AIoT" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/productService/AIoT" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'AIoT' ? 'menuActive' : 'menu_name'
                      )
                            }, " AIoT智能观测台 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_menu_item, { index: "robot" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/productService/robot" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'robot' ? 'menuActive' : 'menu_name'
                      )
                            }, " MC机器人 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "history" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/productService/history" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'history' ? 'menuActive' : 'menu_name'
                      )
                            }, " HISTORY气象台 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "4" }, {
              title: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(activeIndex.value === 'solution' ? 'menuActive' : 'menu_name')
                }, " 解决方案 ", 2)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_el_menu_item, { index: "geoponics" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/solution/geoponics" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'geoponics' ? 'menuActive' : 'menu_name'
                      )
                            }, " 农业气象服务 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "insurance" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/solution/insurance" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'insurance' ? 'menuActive' : 'menu_name'
                      )
                            }, " 保险气象服务 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "tour" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/solution/tour" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'tour' ? 'menuActive' : 'menu_name'
                      )
                            }, " 旅游气象服务 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "aviation" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/solution/aviation" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'aviation' ? 'menuActive' : 'menu_name'
                      )
                            }, " 航空气象服务 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "traffic" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/solution/traffic" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'traffic' ? 'menuActive' : 'menu_name'
                      )
                            }, " 交通气象服务 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_menu_item, { index: "sports" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/solution/sports" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'sports' ? 'menuActive' : 'menu_name'
                      )
                            }, " 体育赛事气象 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "extreme" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/solution/extreme" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'extreme' ? 'menuActive' : 'menu_name'
                      )
                            }, " 危化品气象服务 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "energy" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: "/solution/energy" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                        activeIndex2.value == 'energy' ? 'menuActive' : 'menu_name'
                      )
                            }, " 新能源功率预测 ", 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "5",
              style: {"margin-right":"24px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/zoology/cooperation" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["menu_name", 
                  activeIndex.value === 'zoology' ? 'menuActive' : 'menuActive2'
                ])
                    }, " 合作伙伴 ", 2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "6" }, {
              title: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(activeIndex.value === 'about' ? 'menuActive' : 'menu_name')
                }, " 关于我们 ", 2)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_menu_item, { index: "company" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/about/company" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(
                      activeIndex2.value == 'company' ? 'menuActive' : 'menu_name'
                    )
                          }, " 公司介绍 ", 2)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "recruit" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/about/recruit" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(
                      activeIndex2.value == 'recruit' ? 'menuActive' : 'menu_name'
                    )
                          }, " 招贤纳士 ", 2)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active"])
      ])
    ])
  ]))
}
}

})